<template>
    <div class="row">
        <div class="col-xs-12 text-xs-left">
            <h3 class="modal__title">{{ $t('Do_YOU_WANT_TO_ACTIVATE_ANOTHER_PACKAGE') }}</h3>
            <br /><br />
            <p v-if="activepackage">
                {{ $t('PACKAGE_ALREADY_ACTIVATED') }}<br />
                {{ $t('PACKAGE_EXPIRATION') }}
                <strong>{{ dateFormat(activepackage.lastStockExpirationDate) }}</strong
                ><br />
                {{ $t('IF_ACTIVATE_PACKAGE') }} <strong>{{ addMonth }}</strong>
            </p>
            <br />
            <p>
                {{ $t('ARE_YOU_SURE_YOU_WANT_TO_ACTIVATE') }}
            </p>
            <br />
            <br />

            <div class="text-center">
                <button
                    class="app-btn app-btn--small app-btn-primary-reverse --no-border --no-bg"
                    @click="$emit('close')"
                >
                    {{ $t('CANCEL') }}
                </button>
                <button class="app-btn app-btn--big app-btn-primary" @click="$emit('activate')">
                    {{ $t('ACTIVATE') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['activepackage'],
    computed: {
        addMonth() {
            if (!this.activepackage) {
                return this.dateFormat(this.$moment(Date.now()));
            }
            if (this.$moment(this.activepackage.lastStockExpirationDate) > this.$moment(Date.now())) {
                return this.dateFormat(
                    this.$moment(this.activepackage.lastStockExpirationDate).add(this.activepackage.expire, 'month'),
                );
            } else {
                return this.dateFormat(this.$moment(Date.now()).add(this.activepackage.expire, 'month'));
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// activate-another-package.vue?2bb3800c